import { Dispatch, useCallback } from 'react'
import { closeModal, openConfirmModal } from 'reducks/modal/operations'

const useCloseModalCallback = (dispatch: Dispatch<any>, edited: boolean) => {
  return useCallback(() => {
    // 編集済みであれば確認用モーダルを表示する
    if (edited) {
      dispatch(openConfirmModal())
    } else {
      dispatch(closeModal())
    }
  }, [dispatch, edited])
}

export default useCloseModalCallback
